var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndicatorReadMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7266 4.27337L10.7866 3.33337L6.55997 7.56004L7.49997 8.50004L11.7266 4.27337V4.27337ZM14.5534 3.33337L7.50003 10.3867L4.71336 7.60671L3.77336 8.54671L7.50003 12.2734L15.5 4.27337L14.5534 3.33337V3.33337ZM0 8.54672L3.72667 12.2734L4.66667 11.3334L0.946667 7.60672L0 8.54672V8.54672Z",
    fill: "#969FA2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7266 4.27337L10.7866 3.33337L6.55997 7.56004L7.49997 8.50004L11.7266 4.27337V4.27337ZM14.5534 3.33337L7.50003 10.3867L4.71336 7.60671L3.77336 8.54671L7.50003 12.2734L15.5 4.27337L14.5534 3.33337V3.33337ZM0 8.54672L3.72667 12.2734L4.66667 11.3334L0.946667 7.60672L0 8.54672V8.54672Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorReadMsg);
export default __webpack_public_path__ + "static/media/indicator-read-msg.21817442f7b155af3c1a16ffd4b43fa5.svg";
export { ForwardRef as ReactComponent };